export default __webpack_public_path__ + "static/media/Inventory.0cc96273.svg";